(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartCareTeamHistoryNewController', ChartCareTeamHistoryNewController);

    ChartCareTeamHistoryNewController.$inject = ['ChartCareTeam', 'DTOptionsBuilder', 'DTColumnBuilder', 'DataTablesService',
                                                'chart', '$timeout', '$uibModalInstance', '$rootScope'];

    function ChartCareTeamHistoryNewController(ChartCareTeam, DTOptionsBuilder, DTColumnBuilder, DataTablesService,
                                               chart, $timeout, $uibModalInstance) {
        var vm = this;
        vm.chart = chart;

        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.careTeams = [];

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;

        loadAll();

        function loadAll() {
            ChartCareTeam.getAllByFilter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.careTeams = result;
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.active = false;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }
    }
})();
